// extracted by mini-css-extract-plugin
module.exports = {"powerOutage":"PowerOutage_powerOutage__2BrLv"};